import { TESTIMONIALS } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const PRINCIPLES = [
  {
    icon: "ri-node-tree",
    title: "时间优先",
    desc: "所有内容按事件发生顺序排列，先讲起因，再讲发酵，把反转让事实自然交代，而不是被热搜带着东拼西凑。",
  },
  {
    icon: "ri-file-search-line",
    title: "公开可溯",
    desc: "只整理已公开、可回溯的信息，关键节点尽量标注时间与出处，不给没有出处的单一匿名爆料盖章。",
  },
  {
    icon: "ri-verified-badge-line",
    title: "状态分明",
    desc: "用“进行中 / 已完结 / 持续更新”标注推进状态，让你一眼看清这个瓜还能不能继续蹲、完整程度如何。",
  },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          align="center"
          eyebrow="关于我们"
          title="让吃瓜，不再东翻西帖"
          desc="今日瓜报是一份专注“吃瓜事件盘点与合集时间线”的内容站。我们相信，真正有价值的不只是某个爆点，而是把来龙去脉按顺序讲清楚的能力。"
        />

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {PRINCIPLES.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-secondary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-secondary-100 text-secondary-800">
                <i className={`${p.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 overflow-hidden rounded-2xl border border-background-200 bg-primary-500 px-6 py-10 text-center md:px-10">
          <p className="mx-auto max-w-3xl font-heading text-xl font-bold leading-relaxed text-background-50 md:text-2xl">
            “与其急着站队，不如先把顺序看清楚——
            <br />
            先发生的，往往才决定了后来的一切。”
          </p>
          <p className="mt-4 text-sm text-primary-100">—— 今日瓜报编辑部</p>
        </div>

        <div className="mt-12">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <SectionHeading eyebrow="瓜友口碑" title="新老粉都更省心了" />
            <div className="flex items-center gap-3 text-sm text-foreground-600">
              <span className="flex items-center gap-1 text-accent-600">
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
              </span>
              <span>累计 2.3w+ 条好评反馈</span>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
            {TESTIMONIALS.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6"
              >
                <i className="ri-double-quotes-l text-3xl text-accent-400" />
                <blockquote className="mt-2 flex-1 text-sm leading-7 text-foreground-700">{t.text}</blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-accent-400 to-primary-500 text-sm font-bold text-background-50">
                    {t.avatar}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-400">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}